// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__rjQkX","input":"SearchBar_input__bIy50","icon":"SearchBar_icon__EfDZn"};